/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Karen} from "../Karen";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {KarenReelController} from "../reels/KarenReelController";
import {KarenParsedData} from "../server/data/KarenParsedData";

export class KarenFreespinIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    public async start(flowStateController: FlowStateController) {
        let gameData: KarenParsedData = Karen.model.parsedGameData;
        if (Karen.model.isRestore) {
            gameData = Karen.model.parsedInitData;
            const isFSTrigger: boolean = (gameData.mode === GameMode.NORMAL && gameData.nextMode === GameMode.FREESPIN);
            if (Karen.model.parsedInitData.nextMode === GameMode.FREESPIN) {
                Karen.background.setXWaysFSSize(gameData.fsXWaysSize.toString());
                KarenReelController.currentNumData = Karen.model.parsedInitData.gameAreaSize;
            }
            for (let reelIndex: number = 1; reelIndex < gameData.reels.length; reelIndex++) {
                Karen.reelBackground.bounceReelFrame(reelIndex, KarenReelController.currentNumData[reelIndex]);
                Karen.reels[reelIndex].reelView.updateReelMask(reelIndex, KarenReelController.currentNumData[reelIndex], true);
                if (gameData.stickyXWaysFSPositions![reelIndex] > -1) {
                    Karen.stickyXWView.moveStickyXW(reelIndex, gameData.stickyXWaysFSPositions![reelIndex]);
                }
                if (isFSTrigger) {
                    Karen.stickyXWView.hideAllStickyXW();
                }
                Karen.reels[reelIndex].reelView.setInteractiveSymbols(false);
            }
            Karen.reels[0].reelView.setInteractiveSymbols(false);
            await new Promise<void>(resolve => {
                Karen.freespinIntro.show(resolve);
            });
            SlotGame.keypadPlugin.setZeroBetSpinCounter(gameData.freespinsLeft - 1);
        } else {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(gameData.freespinsLeft - 1);
            for (let reelIndex: number = 1; reelIndex < gameData.reels.length; reelIndex++) {
                if (gameData.stickyXWaysFSPositions![reelIndex] > -1) {
                    Karen.stickyXWView.moveStickyXW(reelIndex, gameData.stickyXWaysFSPositions![reelIndex]);
                }
            }
        }
        SlotGame.apiPlugin.betHandler.zeroBet();
        flowStateController.finish();
    }
}
